import appConfig from "../../../appconfig";
import TimeZonesMgrFactory from "../../../domains2/libraries/timezone/TimeZonesMgr";

const state = {
};

const getters = {
	shopTimeZone: (state, getters) => {
		const fallbackShopTimeZoneIfDoesntExist = ( shop ) => {
			return shop.shopTimeZone ? shop.shopTimeZone : getters.serverData.defaultTimeZone;
		};
		if(getters.globalSelectedShop){
			return fallbackShopTimeZoneIfDoesntExist(getters.globalSelectedShop);
		} else if (getters.getShopData){
			return fallbackShopTimeZoneIfDoesntExist(getters.getShopData);
		}
		return getters.serverData.defaultTimeZone;
	},
	ShopTimeBoxHelper: (state, getters) => {
		return appConfig.timeBoxImpl.helper(getters.shopTimeZone);
	},
	timeZones: () => {
		return TimeZonesMgrFactory().getTimeZones();
	}
};

export default {
	state,
	getters
};
